import React from "react";
import { Phone } from "lucide-react";
import { site } from "../mock";

export default function StickyCall() {
  return (
    <>
      {/* Floating WhatsApp */}
      <a
        href={site.whatsapp}
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-24 right-5 md:bottom-8 md:right-8 z-40 w-14 h-14 rounded-full flex items-center justify-center shadow-2xl fab-wa"
        style={{ background: "#25D366" }}
        aria-label="WhatsApp"
      >
        <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
          <path d="M20.52 3.48A11.94 11.94 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.83c0 2.08.55 4.11 1.6 5.9L0 24l6.44-1.69a11.83 11.83 0 0 0 5.6 1.42h.01c6.53 0 11.83-5.3 11.83-11.83 0-3.16-1.23-6.13-3.36-8.42zM12.05 21.3a9.47 9.47 0 0 1-4.83-1.32l-.35-.21-3.82 1 .02-3.72-.23-.38a9.5 9.5 0 1 1 17.68-4.83c0 5.23-4.26 9.46-8.46 9.46z"/>
          <path d="M17.34 14.4c-.29-.14-1.72-.85-1.98-.95-.27-.1-.46-.14-.65.15-.19.29-.75.94-.92 1.13-.17.19-.34.22-.63.07-.29-.14-1.23-.45-2.34-1.44a8.83 8.83 0 0 1-1.63-2c-.17-.29-.02-.44.13-.59.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.15-.23-.56-.47-.48-.65-.49h-.55c-.19 0-.5.07-.77.36-.27.29-1.02 1-1.02 2.44 0 1.44 1.05 2.83 1.2 3.03.15.19 2.07 3.16 5.02 4.43.7.3 1.25.48 1.68.62.7.22 1.34.19 1.84.11.56-.08 1.72-.7 1.96-1.38.24-.68.24-1.27.17-1.38-.07-.11-.26-.19-.55-.33z"/>
        </svg>
      </a>

      {/* Mobile Call bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 call-bar px-4 py-3 flex gap-2">
        <a href={`tel:${site.phoneRaw}`} className="btn-gold flex-1 rounded-md py-3 text-sm flex items-center justify-center gap-2">
          <Phone className="w-4 h-4" /> Appeler {site.phone}
        </a>
      </div>
    </>
  );
}
